import React from 'react'
import {waitFrames} from "../../../helpers/waitFrames";
import {audioManager} from "../../../audio/audioManager";
//import RunAnimation from './RunAnimation'


class AnimationGenericPain extends React.Component {

  state = {
    hasTriggeredAnimation: false
  };

  componentDidMount() {

    const targets = this.props.event.subjects;
    let delay = 7; //frames

    //TODO: leave this open to use in the future? Pass a custom sfx ID?
    // if (this.props.event.isNervousMistake) {
    //   audioManager.playSfx("sfx_taunt");
    //   delay += 30; //wait for sfx
    // }

    waitFrames(delay, () => {
      this.setState({
        hasTriggeredAnimation: true
      }, () => {
        //Start shaking
        audioManager.playSfx("sfx_iteratePain");
        targets.forEach(id => {
          this.props.handleCombatantStateChange([
            {
              combatantId: id,
              absoluteChanges: {
                laptopFlash: "pain",
                animation: "characterShake",
              }
            }
          ])
        });
        //Stop shaking
        waitFrames(20, () => {
          targets.forEach(id => {
            this.props.handleCombatantStateChange([
              {
                combatantId: id,
                absoluteChanges: {
                  laptopFlash: "none",
                  animation: null,
                }
              }
            ]);

            waitFrames(10, () => {this.props.onEventDone()})

          });
        });
      });
    });
  }

  render() {
    return null
  }
}

export default AnimationGenericPain;